//Authot v.sh. 26/01/2020
//define contants

var config = {
    baseUrl: 'https://api.nsum.net/',
}

export default config;
